import { bodySheet } from './body.js';
import { bottomSheet, topSheet } from './clothes.js';
import { hairBackSheet, hairFrontSheet } from './hair.js';

export const BODY_PARTS = {
  male: bodySheet('male'),
  female: bodySheet('female'),
};

export const HAIR_FRONT_PARTS = {
  short: hairFrontSheet('short'),
  medium: hairFrontSheet('medium'),
  long: hairFrontSheet('long'),
};

export const HAIR_BACK_PARTS = {
  long: hairBackSheet('long'),
};

export const TOP_PARTS = {
  sleeveless: topSheet('sleeveless'),
  shirt: topSheet('shirt'),
  hoodie: topSheet('hoodie'),
};

export const BOTTOM_PARTS = {
  pants: bottomSheet('pants'),
  shorts: bottomSheet('shorts'),
  skirt: bottomSheet('skirt'),
};
